
import { defineComponent } from 'vue';
import Logo from '@/components/Logo.vue';
import TheHeaderButton from '@/components/HiddenAccentButton.vue';
import LoginButton from './LoginButton.vue';

export default defineComponent({
  name: 'TheHeader',
  components: {
    Logo,
    TheHeaderButton,
    LoginButton,
  },
  methods: {
    scrollToAnchor(id: string) {
      const elem = document.getElementById(id);
      if (elem) {
        const a = document.documentElement.scrollTop
          + elem.getBoundingClientRect().top;
        window.scrollTo({
          top: a,
          behavior: 'smooth',
        });
      }
    },
  },
});
